import { Box, Typography, Button, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)<{ width?: string; height?: string }>(
  ({ width = '500px', height = 'auto' }) => ({
    '& .MuiDialog-paper': {
      width,
      minHeight: height,
      maxWidth: 'none',
      overflow: 'hidden',
      borderRadius: '16px',
      padding: '24px',
    },
  })
);

export const HeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '16px',
});

export const AlertIcon = styled(Box)({
  fontSize: '24px',
  color: 'var(--error)',
  marginRight: '12px',
});

export const TitleTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '20px',
  fontWeight: 600,
  color: 'var(--primary-navy)',
});

export const SubtitleTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 400,
  color: 'var(--subtext)',
  marginBottom: '8px',
});

export const SubtitleSecondary = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '12px',
  fontWeight: 400,
  color: 'var(--instructions)',
  marginBottom: '20px',
});

export const ReasonTextArea = styled('textarea')({
  minHeight: '120px',
  padding: '12px',
  fontFamily: 'Outfit',
  fontSize: '14px',
  border: '1px solid var(--border)',
  borderRadius: '8px',
  resize: 'vertical',
  outline: 'none',
  '&:focus': {
    borderColor: 'var(--primary-blue)',
  },
  '&::placeholder': {
    color: 'var(--instructions)',
  },
});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  gap: '12px',
  marginTop: '24px',
});

export const RejectButton = styled(Button)({
  backgroundColor: 'var(--error)',
  color: 'white',
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'none',
  padding: '8px 24px',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: 'var(--error)',
    filter: 'brightness(0.9)',
  },
  '&.Mui-disabled': {
    backgroundColor: 'var(--error)',
    opacity: 0.5,
    color: 'white',
  },
});

export const CancelButton = styled(Button)({
  backgroundColor: 'var(--inactive-btn)',
  color: 'var(--primary-navy)',
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'none',
  padding: '8px 24px',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: 'var(--hover-white)',
  },
});

export const CloseIcon = styled(Box)({
  position: 'absolute',
  top: 16,
  right: 16,
  fontSize: '24px',
  cursor: 'pointer',
  color: 'var(--instructions)',
  '&:hover': {
    color: 'var(--error)',
  },
});

export const RelativePositionBox = styled(Box)({
  position: 'relative',
});
